export default __webpack_public_path__ + "static/media/bg.4d0fbe05.jpeg";